import CurrentPropertyRestrictions from './CurrentPropertyRestrictions';
import Freemium from './Freemium';
import RentGuarantee from './RentGuarantee';
import StreetAddress from './StreetAddress';
import { ListingAvailability } from './ListingAvailability';
import { ScreeningCriteriaStatus } from './ListingCriteria';

const PropertyType = ({ display = '', code = null } = {}) => ({
  display: String(display),
  code: Number(code),
});

const Recommendation = ({ unlockedCount = null, lockedCount = null }) => ({
  unlockedCount: Number(unlockedCount),
  lockedCount: Number(lockedCount),
});

// TODO: sync with RentalManagerUserPropertyDetailsOverviewDto
const PropertyOverview = ({
  address = {},
  freemium = {},
  isArchived = false,
  isActive = false,
  isAddressEditable = false,
  isApplicationsAccepted = false,
  isLeaseBuilderRestricted = false,
  isLeasesRestricted = false,
  isMultifamily = false,
  listingAlias = '',
  listingAvailability = {},
  lastActivatedMs = 0,
  listingType = {},
  name = '',
  photoUrl = '',
  propertyType = {},
  status = '',
  recommendation = {},
  rentGuarantee = {},
  restrictions = {},
  screeningCriteria = {},
  updatedMs = 0,
} = {}) => ({
  address: StreetAddress(address),
  freemium: Freemium(freemium),
  isArchived: Boolean(isArchived),
  isActive: Boolean(isActive),
  isAddressEditable: Boolean(isAddressEditable),
  isApplicationsAccepted: Boolean(isApplicationsAccepted),
  isLeaseBuilderRestricted: Boolean(isLeaseBuilderRestricted),
  isLeasesRestricted: Boolean(isLeasesRestricted),
  isMultifamily: Boolean(isMultifamily),
  lastActivatedMs: Number(lastActivatedMs),
  listingAlias: String(listingAlias),
  listingAvailability: ListingAvailability(listingAvailability),
  listingType: PropertyType(listingType),
  name: String(name),
  photoUrl: String(photoUrl),
  propertyType: PropertyType(propertyType),
  status: String(status),
  recommendation: Recommendation(recommendation),
  rentalProtection: RentGuarantee(rentGuarantee),
  restrictions: CurrentPropertyRestrictions(restrictions),
  screeningCriteria: ScreeningCriteriaStatus(screeningCriteria),
  updatedMs: Number(updatedMs),
});

export default PropertyOverview;

export type PropertyOverviewProps = ReturnType<typeof PropertyOverview>;
